import { __extends } from "tslib";
import { EventBase } from './EventBase';
var URLLoaderEvent = /** @class */ (function (_super) {
    __extends(URLLoaderEvent, _super);
    function URLLoaderEvent(type, urlLoader) {
        var _this = _super.call(this, type) || this;
        _this._urlLoader = urlLoader;
        return _this;
    }
    Object.defineProperty(URLLoaderEvent.prototype, "urlLoader", {
        /**
         *
         */
        get: function () {
            return this._urlLoader;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     */
    URLLoaderEvent.prototype.clone = function () {
        return new URLLoaderEvent(this.type, this._urlLoader);
    };
    URLLoaderEvent.HTTP_STATUS = 'httpStatus';
    URLLoaderEvent.LOAD_ERROR = 'loadError';
    URLLoaderEvent.LOAD_PROGRESS = 'loadProgress';
    URLLoaderEvent.LOAD_START = 'loadStart';
    URLLoaderEvent.LOAD_COMPLETE = 'loadComplete';
    return URLLoaderEvent;
}(EventBase));
export { URLLoaderEvent };
